import o from"mapbox.js";var m="pk.eyJ1IjoiY29ydmEtYWkiLCJhIjoiY2tzeXg1Ym84Mm53NjJvbnZvZ3JxajVwayJ9.3B6ubssBj1UCqN5o25X6pw";o.mapbox.accessToken=m;export{m as MAP_BOX_ACCESS_TOKEN};
